import React, { FC } from "react";

type SvgProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<SvgProps> = ({ width = 14, height = 13 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M15.1689 11.3374V13.3374C15.1697 13.523 15.1316 13.7068 15.0572 13.8769C14.9829 14.047 14.8738 14.1997 14.737 14.3253C14.6001 14.4508 14.4386 14.5463 14.2627 14.6058C14.0869 14.6653 13.9005 14.6874 13.7156 14.6707C11.6641 14.4478 9.69357 13.7468 7.96223 12.624C6.35145 11.6005 4.98579 10.2348 3.96223 8.62402C2.83555 6.88483 2.1344 4.90469 1.91557 2.84402C1.89891 2.65967 1.92082 2.47386 1.9799 2.29844C2.03898 2.12302 2.13395 1.96182 2.25874 1.8251C2.38354 1.68839 2.53544 1.57916 2.70476 1.50437C2.87409 1.42958 3.05713 1.39086 3.24223 1.39069H5.24223C5.56577 1.38751 5.87943 1.50208 6.12474 1.71304C6.37006 1.92401 6.53029 2.21699 6.57557 2.53736C6.65998 3.1774 6.81653 3.80584 7.04223 4.41069C7.13193 4.64931 7.15134 4.90863 7.09817 5.15794C7.045 5.40725 6.92148 5.6361 6.74223 5.81736L5.89557 6.66402C6.8446 8.33305 8.22654 9.71499 9.89557 10.664L10.7422 9.81736C10.9235 9.63811 11.1523 9.51459 11.4016 9.46142C11.651 9.40825 11.9103 9.42766 12.1489 9.51736C12.7537 9.74306 13.3822 9.89961 14.0222 9.98402C14.3461 10.0297 14.6418 10.1928 14.8533 10.4424C15.0647 10.6919 15.177 11.0104 15.1689 11.3374Z"
      stroke="#262626"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
